module.exports = __webpack_public_path__ + "img/icon_heart_21.b52a2bc3.svg";